import { z } from 'zod'
import { Options } from '../../../product/selector/types'
import { FiltersHelpKeys } from '../../../algolia/types'

export const HelpKeys = z.enum([
  ...Options.options, 
  'beveled', 'isHeritageWithBeveled', 'louver', //TODO: move to Options
  ...FiltersHelpKeys.options
])
export type HelpKeys = z.infer<typeof HelpKeys>

export const Input = z.object({
  help: z
    .array(
      z.object({
        name: HelpKeys,
        text: z.string().optional().nullable().default(null),
        images: z
          .array(z.object({ url: z.string().min(1) }))
          .optional()
          .default([]),
        image_position: z.enum(['side', 'bottom']).optional().default('side')
      })
    )
    .optional()
    .default([])
})
export type Input = z.infer<typeof Input>

export type Help = Input['help']

export const _getHelpData = (): Help => {
  try {
    const dataContainer = window.document.getElementById('help-json')

    if (dataContainer == null) {
      throw new Error(
        'Help data container not found [5165d2b8bc8e4be791c370233e9b0198]'
      )
    }

    const input = Input.parse(JSON.parse(dataContainer.innerHTML || '{}'))

    return input.help
  } catch (err) {
    console.error(
      'Help data cannot be accessed [c106b3ee92864239802bae89b3687024]',
      err
    )
    return []
  }
}

let _help: Help | null = null

export const getHelpData = (): Help => {
  _help = _help ?? _getHelpData()

  return _help
}
